import React from 'react';

import SalesChannelsShow from '@shared/sales_channels/SalesChannelsShow';
import { useLoaderData } from 'react-router-dom';

export default function AdminSalesChannelsShow() {
  const salesChannel = useLoaderData();

  return (
    <SalesChannelsShow
      salesChannel={salesChannel}
      role="admin"
    />
  );
}
